<template>
  <div class="liftAdd">
    <form>
      <div class="form-group">
        <h4 class="m-0 mt-3">
          Start Location
        </h4>
        <hr class="m-0 mb-3" />
        <div class="ml-3">
          <div class="form-check form-check-inline mb-3 mt-2">
            <input
              id="useExistingStart"
              v-model="useExistingStart"
              class="form-check-input"
              type="checkbox"
            />
            <label
              class="form-check-label"
              for="useExistingStart"
            >Use Existing</label>
          </div>
          <div class="m-0 mb-1" />
          <template v-if="!useExistingStart">
            <!-- <label>{{ $t("type") }}</label>
            <select
              v-model="startLocation.type"
              :class="[
                'form-control',
                { 'is-invalid': $validator.errors.has('Type') },
              ]"
            >
              <option
                v-for="(sType, index) in cPointTypes"
                :key="`spotType-spot-${index}`"
                :value="sType"
              >
                {{ `${sType}` }}
              </option>
            </select> -->
          </template>
          <template v-else>
            <label>{{ $t("Location") }}</label>
            <select
              v-model="startLocation"
              :class="[
                'form-control',
                { 'is-invalid': $validator.errors.has('Type') },
              ]"
            >
              <optgroup
                v-for="group in locationGroups"
                :key="`loc-group-${group.resortId}`"
                :label="group.label"
              >
                <option
                  v-for="loc in group.locations"
                  :key="`loc-start-${loc.id}`"
                  :value="loc"
                >
                  {{ `Location ${loc.id}` }}
                </option>
              </optgroup>
            </select>
          </template>
          <hr class="m-0 mb-3" />
          <label>{{ $t("altitude") }}</label>
          <input
            v-model="startLocation.location.altitude"
            :class="[
              'form-control',
              { 'is-invalid': $validator.errors.has('Altitude') },
            ]"
            type="text"
          />
          <hr class="m-0 mb-3" />
          <label>{{ $t("latitude") }}</label>
          <input
            v-model="startLocation.location.latitude"
            :class="[
              'form-control',
              { 'is-invalid': $validator.errors.has('Altitude') },
            ]"
            type="text"
          />
          <hr class="m-0 mb-3" />
          <label>{{ $t("longitude") }}</label>
          <input
            v-model="startLocation.location.longitude"
            :class="[
              'form-control',
              { 'is-invalid': $validator.errors.has('Altitude') },
            ]"
            type="text"
          />
          <hr class="m-0 mb-3" />
          <div class="form-check form-check-inline mb-3 mt-2">
            <input
              id="cStartPoint"
              v-model="createStartPoint"
              class="form-check-input"
              type="checkbox"
            />
            <label
              class="form-check-label"
              for="cStartPoint"
            >{{ useExistingStart ? "Upsert" : "Add" }} Start Point</label>
          </div>
          <LoadingPlaceholder v-if="pointLoading && createStartPoint" />
          <div v-else-if="startPoint">
            <h5>Start Point</h5>
            <!-- <hr class="m-0 mb-3" />
            <div class="form-check form-check-inline mb-3 mt-2">
              <input
                id="cUseExistingStart"
                v-model="useExistingStartPoint"
                class="form-check-input"
                type="checkbox"
              />
              <label
                class="form-check-label"
                for="cUseExistingStart"
              >Use Existing Start Point</label>
            </div> -->
            <hr class="m-0 mb-3" />
            <template v-if="useExistingStartPoint">
              <label>{{ $t("Point") }}</label>
              <select
                v-model="selectedStartPointId"
                :class="[
                  'form-control',
                  { 'is-invalid': $validator.errors.has('Type') },
                ]"
              >
                <option
                  v-for="(rp, index) in resortPoints"
                  :key="`spotTyp1e-spot-${index}`"
                  :value="rp.id"
                >
                  {{ `${rp.id} - ${rp.name}` }}
                </option>
              </select>
              <hr class="m-0 mb-3" />
            </template>
            <label>{{ $t("key") }}</label>
            <input
              v-model="startPoint.key"
              :class="[
                'form-control',
                { 'is-invalid': $validator.errors.has('Key') },
              ]"
              type="text"
            />
            <hr class="m-0 mb-3" />
            <label>{{ $t("name") }}</label>
            <input
              v-model="startPoint.name"
              :class="[
                'form-control',
                { 'is-invalid': $validator.errors.has('Name') },
              ]"
              type="text"
            />
            <hr class="m-0 mb-3" />
            <label>Spot type</label>
            <select
              v-model="startPoint.typeId"
              :class="[
                'form-control',
                { 'is-invalid': $validator.errors.has('Type') },
              ]"
            >
              <option
                v-for="(pointType, index) in pointTypes"
                :key="`pointType-spot1-${index}`"
                :value="pointType.id"
              >
                {{ `${pointType.id} - ${pointType.name}` }}
              </option>
            </select>
            <hr class="m-0 mb-3" />
            <label>External ID</label>
            <input
              v-model="startExternalIdsString"
              :class="[
                'form-control',
                { 'is-invalid': $validator.errors.has('st') },
              ]"
              type="text"
            />
            <small
              class="form-text text-muted"
            >You can enter multiple IDs separated by commas.</small>
            <hr class="m-0 mb-3" />
            <div class="form-check form-check-inline mb-3 mt-2">
              <input
                id="active"
                v-model="startPoint.active"
                class="form-check-input"
                type="checkbox"
              />
              <label
                class="form-check-label"
                for="active"
              >Active</label>
            </div>
            <div class="form-check form-check-inline mb-3 mt-2">
              <input
                id="visible"
                v-model="startPoint.visible"
                class="form-check-input"
                type="checkbox"
              />
              <label
                class="form-check-label"
                for="visible"
              >Visible</label>
            </div>
          </div>
        </div>
        <h4 class="m-0 mt-3">
          {{ "End Location" }}
        </h4>
        <hr class="m-0 mb-3" />
        <div class="ml-3">
          <div class="form-check form-check-inline mb-3 mt-2">
            <input
              id="useExistingEnd"
              v-model="useExistingEnd"
              class="form-check-input"
              type="checkbox"
            />
            <label
              class="form-check-label"
              for="useExistingEnd"
            >Use Existing</label>
          </div>
          <div class="m-0 mb-1" />
          <template v-if="!useExistingEnd">
            <!-- <label>{{ $t("type") }}</label>
            <select
              v-model="endLocation.type"
              :class="[
                'form-control',
                { 'is-invalid': $validator.errors.has('Type') },
              ]"
            >
              <option
                v-for="(sType, index) in cPointTypes"
                :key="`spotType-spot-${index}`"
                :value="sType"
              >
                {{ `${sType}` }}
              </option>
            </select> -->
          </template>
          <template v-else>
            <label>{{ $t("Location") }}</label>
            <select
              v-model="endLocation"
              :class="[
                'form-control',
                { 'is-invalid': $validator.errors.has('Type') },
              ]"
            >
              <optgroup
                v-for="group in locationGroups"
                :key="`loc-group-${group.resortId}`"
                :label="group.label"
              >
                <option
                  v-for="loc in group.locations"
                  :key="`loc-end-${loc.id}`"
                  :value="loc"
                >
                  {{ `Location ${loc.id}` }}
                </option>
              </optgroup>
            </select>
          </template>
          <hr class="m-0 mb-3" />
          <label>{{ $t("altitude") }}</label>
          <input
            v-model="endLocation.location.altitude"
            :class="[
              'form-control',
              { 'is-invalid': $validator.errors.has('Altitude') },
            ]"
            type="text"
          />
          <hr class="m-0 mb-3" />
          <label>{{ $t("latitude") }}</label>
          <input
            v-model="endLocation.location.latitude"
            :class="[
              'form-control',
              { 'is-invalid': $validator.errors.has('Altitude') },
            ]"
            type="text"
          />
          <hr class="m-0 mb-3" />
          <label>{{ $t("longitude") }}</label>
          <input
            v-model="endLocation.location.longitude"
            :class="[
              'form-control',
              { 'is-invalid': $validator.errors.has('Altitude') },
            ]"
            type="text"
          />
          <hr class="m-0 mb-3" />
          <div class="form-check form-check-inline mb-3 mt-2">
            <input
              id="cEndPoint"
              v-model="createEndPoint"
              class="form-check-input"
              type="checkbox"
            />
            <label
              class="form-check-label"
              for="cEndPoint"
            >{{ useExistingEnd ? "Upsert" : "Add" }} End Point</label>
          </div>
          <LoadingPlaceholder v-if="pointLoading && createEndPoint" />
          <div v-else-if="endPoint">
            <h5>End Point</h5>
            <!-- <hr class="m-0 mb-3" />
            <div class="form-check form-check-inline mb-3 mt-2">
              <input
                id="cUseExistingEnd"
                v-model="useExistingEndPoint"
                class="form-check-input"
                type="checkbox"
              />
              <label
                class="form-check-label"
                for="cUseExistingEnd"
              >Use Existing End Point</label>
            </div> -->
            <hr class="m-0 mb-3" />
            <template v-if="useExistingEndPoint">
              <label>{{ $t("Point") }}</label>
              <select
                v-model="selectedEndPointId"
                :class="[
                  'form-control',
                  { 'is-invalid': $validator.errors.has('Type') },
                ]"
              >
                <option
                  v-for="(rp, index) in resortPoints"
                  :key="`spotTyp2e-spot-${index}`"
                  :value="rp.id"
                >
                  {{ `${rp.id} - ${rp.name}` }}
                </option>
              </select>
              <hr class="m-0 mb-3" />
            </template>
            <label>{{ $t("key") }}</label>
            <input
              v-model="endPoint.key"
              :class="[
                'form-control',
                { 'is-invalid': $validator.errors.has('Key') },
              ]"
              type="text"
            />
            <hr class="m-0 mb-3" />
            <label>{{ $t("name") }}</label>
            <input
              v-model="endPoint.name"
              :class="[
                'form-control',
                { 'is-invalid': $validator.errors.has('Name') },
              ]"
              type="text"
            />
            <hr class="m-0 mb-3" />
            <label>Spot type</label>
            <select
              v-model="endPoint.typeId"
              :class="[
                'form-control',
                { 'is-invalid': $validator.errors.has('Type') },
              ]"
            >
              <option
                v-for="(pointType, index) in pointTypes"
                :key="`pointType-spot-${index}`"
                :value="pointType.id"
              >
                {{ `${pointType.id} - ${pointType.name}` }}
              </option>
            </select>
            <hr class="m-0 mb-3" />
            <label>External ID</label>
            <input
              v-model="endExternalIdsString"
              :class="[
                'form-control',
                { 'is-invalid': $validator.errors.has('st') },
              ]"
              type="text"
            />
            <small
              class="form-text text-muted"
            >You can enter multiple IDs separated by commas.</small>
            <hr class="m-0 mb-3" />
            <div class="form-check form-check-inline mb-3 mt-2">
              <input
                id="endActive"
                v-model="endPoint.active"
                class="form-check-input"
                type="checkbox"
              />
              <label
                class="form-check-label"
                for="endActive"
              >Active</label>
            </div>
            <div class="form-check form-check-inline mb-3 mt-2">
              <input
                id="endVisible"
                v-model="endPoint.visible"
                class="form-check-input"
                type="checkbox"
              />
              <label
                class="form-check-label"
                for="endVisible"
              >Visible</label>
            </div>
          </div>
        </div>
        <h4 class="m-0 mt-3">
          {{ "Section" }}
        </h4>
        <hr class="m-0 mb-3" />
        <div class="ml-3">
          <label>{{ $t("name") }}</label>
          <input
            v-model="section.name"
            :class="[
              'form-control',
              { 'is-invalid': $validator.errors.has('Name') },
            ]"
            type="text"
          />
          <hr class="m-0 mb-3" />
          <label>{{ $t("type") }}</label>
          <select
            v-model="section.typeId"
            :class="[
              'form-control',
              { 'is-invalid': $validator.errors.has('Type') },
            ]"
          >
            <option
              v-for="(type, index) in sectionTypes"
              :key="`spotType-spot-${index}`"
              :value="type.id"
            >
              {{ `${type.id} - ${type.name}` }}
            </option>
          </select>
          <hr class="m-0 mb-3" />
          <label>{{ $t("length") }}</label>
          <input
            v-model="section.length"
            :class="[
              'form-control',
              { 'is-invalid': $validator.errors.has('Length') },
            ]"
            type="text"
          />
          <label>{{ $t("resortForm.multipleValue") }}</label>
          <hr class="m-0 mb-3" />
          <label>{{ $t("duration") }}</label>
          <input
            v-model="section.duration"
            :class="[
              'form-control',
              { 'is-invalid': $validator.errors.has('Duration') },
            ]"
            type="text"
          />
          <hr class="m-0 mb-3" />
          <div class="form-check form-check-inline mb-3 mt-2">
            <input
              id="actived"
              v-model="section.active"
              class="form-check-input"
              type="checkbox"
            />
            <label
              class="form-check-label"
              for="actived"
            >Active</label>
          </div>
          <hr class="m-0 mb-3" />
          <div class="form-check form-check-inline mb-3 mt-2">
            <input
              id="manuallyAddable"
              v-model="section.manuallyAddable"
              class="form-check-input"
              type="checkbox"
            />
            <label
              class="form-check-label"
              for="manuallyAddable"
            >Manually Addable</label>
          </div>
        </div>
      </div>
      <LoadingPlaceholder v-if="upsertLoading" />
      <button
        v-else
        class="btn btn-primary float-right"
        @click.prevent="addLift()"
      >
        <font-awesome-icon
          class="mr-2"
          icon="check"
        />{{ $t("add") }}
      </button>
      <div class="clearfix" />
    </form>
  </div>
</template>

<script>
import { errorMixin } from "@/mixins/errorMixin.js";

export default {
  name: "LiftAdd",
  mixins: [errorMixin],
  props: {
    resortId: {
      type: Number,
      required: true,
    },
    locations: {
      type: Array,
      default: () => {
        return [];
      },
    },
  },
  data() {
    return {
      useExistingStart: false,
      useExistingEnd: false,
      upsertLoading: false,
      startLocation: {
        id: -1,
        location: {
          altitude: 0,
          latitude: 0,
          longitude: 0,
        },
      },
      endLocation: {
        id: -1,
        location: {
          altitude: 0,
          latitude: 0,
          longitude: 0,
        },
      },
      section: {},
      sectionTypes: null,
      uniqueName: null,
      startPoint: null,
      endPoint: null,
      pointLoading: false,
      createStartPoint: false,
      useExistingStartPoint: false,
      createEndPoint: false,
      useExistingEndPoint: false,
      resortPoints: [],
      pointTypes: [],
      selectedStartPointId: null,
      selectedEndPointId: null,
    };
  },
  computed: {
    locationGroups() {
      const groups = {};
      (this.locations || []).forEach((loc) => {
        const resortId = loc.resortId || this.resortId;
        if (!groups[resortId]) {
          groups[resortId] = [];
        }
        groups[resortId].push(loc);
      });
      return Object.keys(groups)
        .map((id) => ({
          resortId: Number(id),
          label: `Resort ${id}`,
          locations: groups[id],
        }))
        .sort((a, b) => a.resortId - b.resortId);
    },
    startExternalIdsString: {
      get() {
        if (this.startPoint.externalIds) {
          return this.startPoint.externalIds.join(",");
        }
        return "";
      },
      set(val) {
        this.startPoint.externalIds = val.split(",").map((x) => x.trim());
      },
    },
    endExternalIdsString: {
      get() {
        if (this.endPoint.externalIds) {
          return this.endPoint.externalIds.join(",");
        }
        return "";
      },
      set(val) {
        this.endPoint.externalIds = val.split(",").map((x) => x.trim());
      },
    },
  },
  watch: {
    createStartPoint() {
      if (this.createStartPoint) {
        const match = this.resortPoints.find(
          (rp) =>
            rp.locationId === Number(this.startLocation ? this.startLocation.id : -100)
        );
        this.startPoint = match
          ? this.clone(match)
          : {
              id: -1,
              externalIds: [],
            };
      } else {
        this.startPoint = null;
      }
    },
    createEndPoint() {
      if (this.createEndPoint) {
        const match = this.resortPoints.find(
          (rp) =>
            rp.locationId === Number(this.endLocation ? this.endLocation.id : -100)
        );
        this.endPoint = match
          ? this.clone(match)
          : {
              id: -1,
              externalIds: [],
            };
      } else {
        this.endPoint = null;
      }
    },
    useExistingStartPoint() {
      if (!this.useExistingStartPoint) {
        this.startPoint = {
          id: -1,
          externalIds: [],
        };
        this.selectedStartPointId = null;
      } else {
        this.startPoint = {
          externalIds: [],
        };
        this.selectedStartPointId = null;
      }
    },
    useExistingEndPoint() {
      if (!this.useExistingEndPoint) {
        this.endPoint = {
          id: -1,
          externalIds: [],
        };
        this.selectedEndPointId = null;
      } else {
        this.endPoint = {
          externalIds: [],
        };
        this.selectedEndPointId = null;
      }
    },
    selectedStartPointId(val) {
      if (!this.useExistingStartPoint) {
        return;
      }
      const match = this.resortPoints.find((rp) => rp.locationId === Number(val));
      this.startPoint = match
        ? this.clone(match)
        : {
            id: -1,
            externalIds: [],
          };
    },
    selectedEndPointId(val) {
      if (!this.useExistingEndPoint) {
        return;
      }
      const match = this.resortPoints.find((rp) => rp.locationId === Number(val));
      this.endPoint = match
        ? this.clone(match)
        : {
            id: -1,
            externalIds: [],
          };
    },
    useExistingStart() {
      if (this.useExistingStart && this.locations.length > 0) {
        this.startLocation = this.locations[0];
        if (this.createStartPoint) {
          const match = this.resortPoints.find(
            (rp) => rp.locationId === Number(this.startLocation.id)
          );
          this.startPoint = match
            ? this.clone(match)
            : {
                id: -1,
                externalIds: [],
              };
        }
      } else {
        this.startLocation = {
          id: -1,
          location: {
            altitude: null,
            latitude: null,
            longitude: null,
          },
        };
        if (this.createStartPoint) {
          this.startPoint = {
            id: -1,
            externalIds: [],
          };
        }
      }
    },
    useExistingEnd() {
      if (this.useExistingEnd && this.locations.length > 0) {
        this.endLocation = this.locations[0];
        if (this.createEndPoint) {
          const match = this.resortPoints.find(
            (rp) => rp.locationId === Number(this.endLocation.id)
          );
          this.endPoint = match
            ? this.clone(match)
            : {
                id: -1,
                externalIds: [],
              };
        }
      } else {
        this.endLocation = {
          id: -1,
          location: {
            altitude: null,
            latitude: null,
            longitude: null,
          },
        };
        if (this.createEndPoint) {
          this.endPoint = {
            id: -1,
            externalIds: [],
          };
        }
      }
    },
    'startLocation.id'() {
      if (this.startLocation.id && this.createStartPoint) {
        const match = this.resortPoints.find(
          (rp) =>
            rp.locationId === Number(this.startLocation ? this.startLocation.id : -100)
        );
        this.startPoint = match
          ? this.clone(match)
          : {
              id: -1,
              externalIds: [],
            };
      }
    },
    'endLocation.id'() {
      if (this.endLocation.id && this.createEndPoint) {
        const match = this.resortPoints.find(
          (rp) =>
            rp.locationId === Number(this.endLocation ? this.endLocation.id : -100)
        );
        this.endPoint = match
          ? this.clone(match)
          : {
              id: -1,
              externalIds: [],
            };
      }
    }
  },
  created() {
    this.getPointTypes();
    this.getResortLifts();
    this.getSectionTypes();
  },
  methods: {
    clone(item) {
      return JSON.parse(JSON.stringify(item));
    },
    async addLift() {
      this.upsertLoading = true;
      this.cleanExternalIds(this.startPoint);
      this.cleanExternalIds(this.endPoint);
      this.section.resortId = this.resortId;
      var lift = {
        section: this.section,
        startLocation: this.startLocation,
        endLocation: this.endLocation,
        startPoint: this.startPoint,
        endPoint: this.endPoint,
      };
      await this.axios
        .post(`/Resort/CreateLift`, lift)
        .then(() => {
          this.$snotify.success(this.$t("resortForm.addedSuccessfullyLift"));
          this.$emit("reload");
          this.error_clear();
          this.upsertLoading = false;
          this.reloadResortCache()
        })
        .catch((error) => {
          this.error_clear();
          this.error_validate(error);
        });
    },
    reloadResortCache () {
      this.axios.post(`/Resort/ReloadResortCache`)
      .then(() => {
      })
      .catch(() => {
        this.$snotify.success('Reload Resort Cache not successfull - changes are not yet applied to the system!');
      });
    },
    getSectionTypes() {
      this.axios
        .get(`/Resort/GetResortSectionTypes`)
        .then((response) => {
          this.sectionTypes = response.data;
          this.section.type = this.sectionTypes[0];
        })
        .finally(() => {
          this.loading = false;
        });
    },
    getResortLifts() {
      this.pointLoading = true;
      this.axios
        .get(`/Resort/GetResortLiftPoint?resortId=${this.resortId}&includeSharedResorts=true`)
        .then((response) => {
          this.resortPoints = response.data;
        })
        .finally(() => {
          this.pointLoading = false;
        });
    },
    getPointTypes() {
      this.loading = true;
      this.axios
        .get(`/Resort/GetPointTypes`)
        .then((response) => {
          this.pointTypes = response.data;
          this.pointTypes = this.pointTypes.filter(
            (x) => x.id === 1 || x.id === 2
          );
        })
        .finally(() => {
          this.loading = false;
        });
    },
    cleanExternalIds(point) {
      if (!point || !point.externalIds) {
        return;
      }
      point.externalIds = point.externalIds.filter((x) => x && x.length > 0);
    },
  },
};
</script>

<style scoped>
.liftAdd .progress {
  display: flex;
  flex: 1 1 auto;
  width: 1%;
  height: 20px;
  font-size: 1rem;
}
</style>
